import React from 'react'
import { useLocation } from 'react-router'

import { pathFragmentRecord } from '~/routes/paths'
import { getMatchedParams } from '~/utils'

const { appRoot, brandAccountFragment, surveyFragment } = pathFragmentRecord

/**
 * 現在のURLパスから抽出したパラメータオブジェクトを返すカスタムフックです。
 *
 * @returns パラメータオブジェクト。
 */
export const useRouteParams = () => {
  const { pathname } = useLocation()

  return React.useMemo(
    () => ({
      appRootPath: getMatchedParams(pathname, appRoot, true)?.appRootPath,
      brandAccountId: getMatchedParams(pathname, brandAccountFragment)
        ?.brandAccountId,
      surveyId: getMatchedParams(pathname, surveyFragment)?.surveyId,
    }),
    [pathname],
  )
}
